import React from 'react';
import { Button } from '../ui/button';
import { Loader2, Shield, CreditCard } from 'lucide-react';

export default function StripePackages({ packages, onCheckout, loading }) {
  if (packages.length === 0) {
    return (
      <div className="text-center py-8">
        <Loader2 className="w-8 h-8 animate-spin text-blue-500 mx-auto mb-3" />
        <p className="text-slate-400">Loading packages...</p>
      </div>
    );
  }

  return (
    <div className="stat-card">
      <div className="mb-6">
        <h2 className="text-xl font-semibold flex items-center gap-2">
          <CreditCard className="w-5 h-5 text-blue-400" />
          Credit Card Payment
        </h2>
        <p className="text-sm text-slate-400 mt-1">
          Secure payment processing via Stripe
        </p>
      </div>
      
      <div className="grid gap-4">
        {packages.map((pkg) => (
          <div
            key={pkg.id}
            className="bg-slate-800/50 rounded-xl p-4 hover:bg-slate-800/70 transition-all border border-slate-700/50 hover:border-blue-500/50"
          >
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-semibold text-lg">{pkg.name}</h3>
                <p className="text-sm text-slate-400">{pkg.description}</p>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-right">
                  <p className="text-2xl font-bold text-emerald-400">
                    ${pkg.amount.toFixed(2)}
                  </p>
                  <p className="text-xs text-slate-500">USD</p>
                </div>
                <Button
                  onClick={() => onCheckout(pkg.id)}
                  disabled={loading}
                  className="gradient-accent"
                  data-testid={`stripe-checkout-${pkg.id}`}
                >
                  {loading ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    'Checkout'
                  )}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-6 p-4 bg-blue-500/10 border border-blue-500/30 rounded-lg">
        <div className="flex items-start gap-3">
          <Shield className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
          <div className="text-sm">
            <p className="text-blue-300 font-medium mb-1">Secure Payment</p>
            <p className="text-slate-400">
              All transactions are processed securely through Stripe. 
              Your payment information is never stored on our servers.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
